var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29 4.60875C8.145 4.75375 8.145 4.99375 8.29 5.13875L11.03 7.87875H4.375C4.17 7.87875 4 8.04875 4 8.25375C4 8.45875 4.17 8.62875 4.375 8.62875H11.065L8.375 11.3187C8.23 11.4637 8.23 11.7037 8.375 11.8487C8.45 11.9237 8.545 11.9587 8.64 11.9587C8.735 11.9587 8.83 11.9237 8.905 11.8487L12.485 8.26875L8.825 4.60875C8.68 4.46375 8.44 4.46375 8.295 4.60875H8.29Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNext);
export default __webpack_public_path__ + "static/media/Ico_next.110336341560b0c0e3f44f91cd3b4b73.svg";
export { ForwardRef as ReactComponent };